import React, { useRef, useState, useEffect } from 'react';
import './stick.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Container, Grid, Link } from '@mui/material';
function NaviStick() {
const routeData = [
{ id: 1, title: "Katra", distance: "0 KM" },
{ id: 2, title: "Banganga", distance: "1.5 KM" },
{ id: 3, title: "Charan Paduka", distance: "3.5 KM" },
{ id: 4, title: "Adhkuwari", distance: "6 KM" },
{ id: 5, title: "Himkoti", distance: "8.5 KM" },
{ id: 6, title: "Bhawan", distance: "13 KM" },
];
const helpData = [
{
id: 1,
title: "Reduce Fatigue",
description: "Provides physical support throughout the climb.",
icon: "/assets/navi-stick/icon1.svg",
},
{
id: 2,
title: "Improve Balance",
description: "Offers stability on steep and uneven paths.",
icon: "/assets/navi-stick/icon2.svg",
},
{
id: 3,
title: "Trekking Support",
description: "Designed to make your yatra easier and safer.",
icon: "/assets/navi-stick/icon3.svg",
},
];


const pressData = [
{
id: 1,
title: "Notify Family",
description: "Instant alert sent to your registered contacts.",
icon: "/assets/navi-stick/icon6.svg",
},
{
id: 2,
title: "Share Location",
description: "Live location shared in real-time.",
icon: "/assets/navi-stick/icon5.svg",
},
{
id: 3,
title: "Trigger Alerts",
description: "Local support teams get notified quickly.",
icon: "/assets/navi-stick/icon4.svg",
},
];
return (
<>
<Box className="hero-banner">
   <Container maxWidth="md">
      <Grid
         container
         alignItems="center"
         >
         <Grid item xs={12} md={12}>
            <div className="hero-content">
               <span className="badge-tag">Sacred Journey</span>
               <h1>The Journey is Sacred,</h1>
               <p>
                  Every year, millions of devotees undertake the{" "}
                  <strong>13 km pilgrimage</strong> to seek the blessings of{" "}
                  <strong>Mata Vaishno Devi.</strong>
               </p>
               <ul className="hero-list">
                  <li><i className="fa fa-arrow-right"></i> Some walk comfortably.</li>
                  <li><i className="fa fa-arrow-right"></i> Others face fatigue.</li>
                  <li><i className="fa fa-arrow-right"></i> Steep climbs.</li>
                  <li><i className="fa fa-arrow-right"></i> Crowded pathways.</li>
                  <li><i className="fa fa-arrow-right"></i> Unexpected emergencies.</li>
               </ul>
               <div className="hero-buttons">
                  <a href="/contact-us" className="reserve-btn text-decoration-none">
                  Reserve Your Navi Stick
                  </a>
                  <a href="#thirdBanner" className="learn-btn text-decoration-none">
                  See How It Helps
                  </a>
               </div>
            </div>
         </Grid>
      </Grid>
   </Container>
</Box>
<section className="route-section">
   <Container maxWidth="md">
      <Grid container>
         <Grid size={{ xs: 12 }}>
         <div className="route-wrapper">
            <div className="route-line"></div>
            <Grid container justifyContent="space-between" spacing={0}>
               {routeData.map((item) => (
               <Grid
               key={item.id}
               size={{
               xs: 6,
               sm: 4,
               md: 2,
               }}
               >
               <div className="route-item">
                  <div className="icon-box">
                     <div className="count">{item.id}</div>
                     <svg
                        width="18"
                        height="28"
                        viewBox="0 0 29 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                           d="M14.5 0C10.6544 0 6.96623 1.52767 4.24695 4.24695C1.52767 6.96623 0 10.6544 0 14.5C0 22.5072 14.5 38.6667 14.5 38.6667C14.5 38.6667 29 22.5072 29 14.5C29 10.6544 27.4723 6.96623 24.753 4.24695C22.0338 1.52767 18.3456 0 14.5 0ZM14.5 23.3611C12.7474 23.3611 11.0342 22.8414 9.57703 21.8677C8.11983 20.8941 6.98408 19.5102 6.3134 17.891C5.64272 16.2718 5.46725 14.4902 5.80915 12.7713C6.15106 11.0524 6.995 9.4735 8.23425 8.23425C9.4735 6.995 11.0524 6.15106 12.7713 5.80915C14.4902 5.46725 16.2718 5.64272 17.891 6.3134C19.5102 6.98408 20.8941 8.11983 21.8677 9.57703C22.8414 11.0342 23.3611 12.7474 23.3611 14.5C23.3611 16.8501 22.4275 19.104 20.7658 20.7658C19.104 22.4275 16.8501 23.3611 14.5 23.3611Z"
                           fill="white"
                           />
                        <path
                           d="M14.5004 18.5278C16.7249 18.5278 18.5282 16.7245 18.5282 14.5C18.5282 12.2755 16.7249 10.4722 14.5004 10.4722C12.276 10.4722 10.4727 12.2755 10.4727 14.5C10.4727 16.7245 12.276 18.5278 14.5004 18.5278Z"
                           fill="white"
                           />
                     </svg>
                  </div>
                  <h5>{item.title}</h5>
                  <span>{item.distance}</span>
               </div>
            </Grid>
            ))}
      </Grid>
      </div>
      <div className="info-box">
         <svg
            width="52"
            height="41"
            viewBox="0 0 52 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <g clipPath="url(#clip0_1752_377)">
               <path
                  d="M50.9929 27.649C50.9376 28.4884 50.5732 29.0736 50.1769 28.9561C45.7551 27.6405 39.8052 19.1987 37.9653 16.4535C36.2967 20.5581 34.328 23.5538 33.0526 25.2592C34.8823 26.5536 36.7158 27.5383 38.486 28.0948C38.8808 28.2189 39.1535 28.9993 39.095 29.8378C39.0418 30.6002 38.7333 31.1481 38.381 31.1481C38.3458 31.1481 38.3101 31.1426 38.2744 31.1312C34.6522 29.9926 30.5572 27.0899 26.432 22.7374C23.0008 19.1169 19.7951 14.7537 17.3252 10.3539C15.8271 13.5115 10.8919 22.4156 0.891115 27.4999C0.502423 27.6968 0.113007 27.189 0.0199895 26.3646C-0.0728219 25.5401 0.166382 24.712 0.554558 24.5146C12.0879 18.6512 16.6737 7.36217 16.7186 7.24881C16.8437 6.9335 17.0239 6.73704 17.2176 6.70612C17.4121 6.67586 17.6031 6.80984 17.749 7.08195C20.9387 13.0316 26.0018 19.6122 31.283 23.9118C32.1036 22.951 35.1157 19.1908 37.2723 13.4186C37.5142 12.7715 37.9539 12.647 38.2674 13.1372C38.3396 13.2506 45.5595 24.4824 50.3774 25.916C50.7727 26.0337 51.0483 26.8095 50.9929 27.649ZM28.5487 32.1701C28.4058 32.5337 28.2005 32.7211 27.9937 32.7211C27.8304 32.7211 27.666 32.6041 27.5309 32.3642C27.2246 31.8208 27.1837 30.8528 27.4395 30.2024C27.7427 29.4317 28.0927 28.6382 28.4801 27.8442C28.7675 27.2557 29.2248 27.273 29.5019 27.8828C29.7791 28.4928 29.7708 29.4644 29.4836 30.0531C29.1335 30.7712 28.8189 31.4834 28.5487 32.1701Z"
                  fill="#00C2AF"
                  stroke="#00C2AF"
                  />
            </g>
            <defs>
               <clipPath id="clip0_1752_377">
                  <rect width="52" height="41" fill="white" />
               </clipPath>
            </defs>
         </svg>
         <p>
            From Katra to Bhawan, the 13 km journey is a test of devotion,
            determination and faith.
         </p>
      </div>
      </Grid>
      </Grid>
   </Container>
</section>
<section className="help-section">
   <Container maxWidth="md">
      <div className="section-badge">
         NAVI STICK HELPS YOU
      </div>
      <Grid container spacing={4} className="mt-3">
         {helpData.map((item) => (
         <Grid
         key={item.id}
         size={{
         xs: 12,
         sm: 6,
         md: 4,
         }}
         >
         <div className="help-card">
            <div className="icon-circle">
               <img src={item.icon} />
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
         </div>
      </Grid>
      ))}
      </Grid>
   </Container>
</section>
<Box className="hero-banner secondBanner">
   <Container maxWidth="md">
      <Grid
         container
         alignItems="center"
         >
         <Grid item xs={12} md={12}>
            <div className="hero-content">
               <h1>Walking at Night?</h1>
               <p>
                  Many pilgrims prefer travelling during cooler night hours. Dark pathways and uneven surfaces can make the trek difficult.
               </p>
               <span className="badge-tag">Built-in led Path Light</span>
               <ul className="hero-list mb-3">
                  <li><i><img src="/assets/navi-stick/icon7.svg" height="18px" alt="" /></i> Illuminates the path ahead</li>
                  <li><i><img src="/assets/navi-stick/icon8.svg" height="18px" alt="" /></i> Improves visibility</li>
                  <li><i><img src="/assets/navi-stick/icon9.svg" height="18px" alt="" /></i> Enhances safety during night treks</li>
               </ul>
               <p className='mb-0'>
                  Because faith never stops after sunset.
               </p>
            </div>
         </Grid>
      </Grid>
   </Container>
</Box>
<Box className="hero-banner thirdBanner" id="thirdBanner">
   <Container maxWidth="md">
      <Grid
         container
         alignItems="center"
         >
         <Grid item xs={12} size={{ md: 12 }}>
            <div className="hero-content w-100">
               <h1>Help at the Press of a Button</h1>
               <p className='mb-0'>
                  Unexpected situations can happen to anyone.
               </p>
               <p className='mt-0'>Whether it's fatigue, dizziness, a medical emergency, or getting separated help is just one press away.</p>
               <ul className="hero-list mb-3">
                  <li>Fatigue <i className='ms-2'><img src="/assets/navi-stick/icon10.svg" height="18px" alt="" /></i></li>
                  <li>Dizziness <i className='ms-2'><img src="/assets/navi-stick/icon11.svg" height="18px" alt="" /></i></li>
                  <li>Medical Emergencies <i className='ms-2'><img src="/assets/navi-stick/icon12.svg" height="18px" alt="" /></i></li>
                  <li>Getting Separated <i className='ms-2'><img src="/assets/navi-stick/icon13.svg" height="18px" alt="" /></i></li>
               </ul>
               <p className='mb-0'>
                  Because faith never stops after sunset.
               </p>
            </div>
         </Grid>
      </Grid>
   </Container>
</Box>

<section className="help-section">
   <Container maxWidth="md">
      <div className="section-badge">
         ONE PRESS CAN
      </div>
      <Grid container spacing={4} className="mt-3">
         {pressData.map((item) => (
         <Grid
         key={item.id}
         size={{
         xs: 12,
         sm: 6,
         md: 4,
         }}
         >
         <div className="help-card">
            <div className="icon-circle">
               <img src={item.icon} />
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
         </div>
      </Grid>
      ))}
      </Grid>
   </Container>
</section>


<section className="coming-soon-section">
      <Container maxWidth="md">
        <Grid container justifyContent="center">
          <Grid size={{ xs: 12, md: 12, lg: 12, }}>
            <div className="top-heading">
              NOT JUST A STICK,
              <span>A COMPLETE PILGRIM SAFETY SERVICE</span>
            </div>

            <div className="coming-badge">
              COMING SOON (NAVI STICK)
            </div>

            <p className="description">
              A companion for every step towards Mata Rani.
              <br />
              Faith takes you forward.
              <br />
              <strong>We help you stay safe.</strong>
            </p>

            <a href="#" className="register-btn">
              Register your interest today
            </a>
          </Grid>
        </Grid>
      </Container>
    </section>

</>
);
}
export default NaviStick;